import { Injectable } from '@angular/core';
// import { LessonType, PartyState, ShapeTypeEnum } from '@constants/commonenums';
// import { CacheService } from '@core/services/cache.service';
// import { TableShapeType } from '@models/RestaurantDTO';
// import { Utilities } from '@utilities/utilities';
import { fabric } from 'fabric';
import _ from 'lodash';
import moment from 'moment';
import { ShapeTypeEnum } from 'src/app/shared/constants/commonenums';
// import { controlSettings } from '../constants/globalConstants';
// import { LayoutConfig } from '../models/global.interface';

@Injectable()
export class LayoutFunctions {
  propertyChanges = ['Walls', 'Shapes', 'Labels'];
  vipIcon: any = '';
  linkIcon: any = '';
  partyNotesWithSpecialIcon: any = '';
  partyNotesWithoutSpecialMealIcon: any = '';
  favIcon: any = '';
  blockIcon: any = '';
  TableselectIcon: any = '';

  public constructor() {
  }


  findminObject(tables?, labels?, walls?, shapes?) {
    const newtables = _.cloneDeep(tables.map(obj => ({ ...obj, tempname: 'table' })));
    const newlabels = _.cloneDeep(labels.map(obj => ({ ...obj, tempname: 'label' })));
    const newwalls = _.cloneDeep(walls.map(obj => ({ ...obj, tempname: 'wall' })));
    const newshapes = _.cloneDeep(shapes.map(obj => ({ ...obj, tempname: 'area' })));

    const allObjects = _.cloneDeep(newtables.concat(newlabels, newwalls, newshapes));
    allObjects.forEach(element => {
      if (element.tempname == 'wall') {
        const minx = _.minBy(element.Points, (e) => { return e['X']; });
        const miny = _.minBy(element.Points, (e) => { return e['Y']; });
        element.totalminDataHeight = miny['Y'];
        element.totalminDataWidth = minx['X'];
      }
      else if (element.tempname == 'label') {
        const findstringlength = element.Text.length;
        let getwidth = 2;
        let getHeight = 2;
        const angles = element.Angle;
        if ((angles >= 0 && angles <= 20) || (angles >= 160 && angles <= 200) || (angles >= 340 && angles <= 360)) {
          getwidth = findstringlength / 2;
        } else {
          getHeight = findstringlength / 2;
        }
        element.totalminDataHeight = element.Top - (getHeight);
        element.totalminDataWidth = element.Left - (getwidth);
      }
      else if (element.tempname == 'table') {
        element.totalminDataHeight = element.Top - ((element.Height / 2) + 14);
        element.totalminDataWidth = element.Left - ((element.Width / 2) + 14);
      } else if (element.tempname == 'area') {
        element.totalminDataHeight = element.Top;
        element.totalminDataWidth = element.Left;
      } else {
        element.totalminDataHeight = element.Top - element.Height;
        element.totalminDataWidth = element.Left - element.Width;
      }
    });

    return allObjects;

  }

  findmaxObject(tables?, labels?, walls?, shapes?) {
    const afternewtables = _.cloneDeep(tables.map(obj => ({ ...obj, tempname: 'table' })));
    const afternewlabels = _.cloneDeep(labels.map(obj => ({ ...obj, tempname: 'label' })));
    const afternewwalls = _.cloneDeep(walls.map(obj => ({ ...obj, tempname: 'wall' })));
    const afternewshapes = _.cloneDeep(shapes.map(obj => ({ ...obj, tempname: 'area' })));

    const allObjects = _.cloneDeep(afternewtables.concat(afternewlabels, afternewwalls, afternewshapes));
    // basicTables = _.cloneDeep(tables.concat(labels, walls, shapes));

    allObjects.forEach(element => {
      if (element.tempname == 'wall') {
        const maxx = _.maxBy(element.Points, (e) => { return e['X']; });
        const maxy = _.maxBy(element.Points, (e) => { return e['Y']; });
        element.totalDataHeight = maxy['Y'] + 10;
        element.totalDataWidth = maxx['X'] + 10;
      }
      else if (element.tempname == 'label') {
        const findstringlength = element.Text.length;
        let getwidth = 11;
        let getHeight = 11;
        const angles = element.Angle;
        if ((angles >= 0 && angles <= 20) || (angles >= 160 && angles <= 200) || (angles >= 340 && angles <= 360)) {
          getwidth = findstringlength * 10.2 / 2;
        } else {
          getHeight = findstringlength * 10.2 / 2;
        }
        element.totalDataHeight = getHeight + element.Top;
        element.totalDataWidth = getwidth + element.Left;
      }
      else if (element.tempname == 'table') {
        element.totalDataHeight = (element.Height) + element.Top;
        element.totalDataWidth = (element.Width) + element.Left;
      } else if (element.tempname == 'area') {
        element.totalDataHeight = element.Height + element.Top + 15;
        element.totalDataWidth = element.Width + element.Left + 15;
      } else {
        element.totalDataHeight = element.Height / 2 + element.Top;
        element.totalDataWidth = element.Width / 2 + element.Left;
      }

    });

    return allObjects;
  }

  

  drawRectangleSeat(obj, that, colorData) {
    const color = '#444444';
    const objectWidth = obj.width;
    const objectHeight = obj.height;
    let setArray;
    const partySize = obj.MaxPartySize > 6 ? 6 : obj.MaxPartySize;
    switch (partySize) {
      case 1:
        setArray = ['left'];
        break;
      case 2:
        setArray = ['left', 'right'];
        break;
      case 3:
        setArray = ['left', 'top', 'right'];
        break;
      case 4:
        setArray = ['left', 'top', 'right', 'bottom'];
        break;
      case 5:
        setArray = ['left', 'top-right', 'top-left', 'right', 'bottom'];
        break;
      case 6:
        setArray = ['left', 'top-right', 'top-left', 'right', 'bottom-left', 'bottom-right'];
        break;
      default:
        break;
    }

    return this.drawSeat(obj, setArray, this, color);
  }

  
  drawSeat(obj, seatArray, that, color) {
    const tableObj = [];
    const strokeWidth = 4;
    // tableObj.push(obj);
    const scale = obj._objects.filter(x => x.name == 'shape')[0].scaleX;
    const shape = obj._objects.filter(x => x.name == 'shape')[0]
    seatArray.forEach(element => {
      switch (element) {
        case 'top': {
          const ff = this.rectSeat(obj.left - (obj.width / 4), (obj.top - (obj.height / 2) - 6), obj.left + (obj.width / 4), (obj.top - (obj.height / 2) - 6), scale, color);
          tableObj.push(ff);
          break;
          // obj.addWithUpdate(ff);
        }

        case 'left': {
          // const ff = this.rectSeat((obj.left - 6), (obj.top + obj.height / 2) - (obj.height / 4) - 5, (obj.left - 6), (obj.top + obj.height / 2) + (obj.height / 4), scale, color);
          // tslint:disable-next-line: max-line-length
          const ff = this.rectSeat((obj.left - (obj.width / 2) - 4), (obj.top - (obj.height / 4) - 4), (obj.left - (obj.width / 2) - 4), (obj.top + obj.height / 4), scale, color);
          tableObj.push(ff);
          break;
          // obj.addWithUpdate(ff);
        }

        case 'right': {
          const ff = this.rectSeat((obj.left + (obj.width / 2) - 1), (obj.top - (obj.height / 4) - 4), (obj.left + (obj.width / 2) - 1), (obj.top + obj.height / 4), scale, color);
          tableObj.push(ff);
          break;
          // obj.addWithUpdate(ff);

        }

        case 'bottom': {
          const ff = this.rectSeat((obj.left - (obj.width / 4)), (obj.top + (obj.height / 2)), obj.left + (obj.width / 4), (obj.top + (obj.height / 2)), scale, color);
          tableObj.push(ff);
          break;
          // obj.addWithUpdate(ff);

        }

        case 'top-right': {
          const ff = this.rectSeat(obj.left + (obj.width / 8), (obj.top - (obj.height / 2) - 6), obj.left + (obj.width / 2) - (obj.width / 8), (obj.top - (obj.height / 2) - 6), scale, color);
          tableObj.push(ff);
          break;
          // obj.addWithUpdate(ff);
        }

        case 'top-left': {
          const ff = this.rectSeat(obj.left - (obj.width / 2) + (obj.width / 8), (obj.top - (obj.height / 2) - 6), obj.left - (obj.width / 8), (obj.top - (obj.height / 2) - 6), scale, color);
          tableObj.push(ff);
          break;
          // obj.addWithUpdate(ff);
        }

        case 'bottom-right': {
          const ff = this.rectSeat(obj.left + (obj.width / 8), (obj.top + (obj.height / 2)), obj.left + (obj.width / 2) - (obj.width / 8), (obj.top + (obj.height / 2)), scale, color);
          tableObj.push(ff);
          break;
          // obj.addWithUpdate(ff);
        }

        case 'bottom-left': {
          const ff = this.rectSeat(obj.left - (obj.width / 2) + (obj.width / 8), (obj.top + (obj.height / 2)), obj.left - (obj.width / 8), (obj.top + (obj.height / 2)), scale, color);
          tableObj.push(ff);
          break;
          // obj.addWithUpdate(ff);
        }
      }

    });
    // that.tableObj = [];
    // that.tableObj = tableObj;
    return tableObj;
    // that.canvas.renderAll();


  }

  drawSeatEllipse(obj, seatArray, that, color) {
    const tableObj = [];
    const strokeWidth = 4;
    // tableObj.push(obj);
    const scale = obj._objects.filter(x => x.name == 'shape')[0].scaleX;
    const shape = obj._objects.filter(x => x.name == 'shape')[0];
    const radius = obj.radius;
    const seat = obj.MaxPartySize > 6 ? 6 : obj.MaxPartySize;
    const myTotal = seat * 8;
    var startAngle = Math.PI * 2 * ((myTotal / seat) / myTotal);

    seatArray.forEach(element => {
      switch (element) {
        case 'top': {
          const ff = this.curvedSeat(obj.MaxPartySize > 6 ? 6 : obj.MaxPartySize, radius, color, 'green', this, obj, startAngle, color);
          tableObj.push(ff);
          break;
        }

        case 'bottom': {
          const ff = this.curvedSeat(obj.MaxPartySize > 6 ? 6 : obj.MaxPartySize, radius, color, 'green', this, obj, startAngle, color);
          tableObj.push(ff);
          break;
        }

      }
      startAngle += Math.PI * 2 * ((myTotal / seat) / myTotal);

    });
    // that.tableObj = [];
    // that.tableObj = tableObj;
    return tableObj;
    // that.canvas.renderAll();


  }
  rectSeat(x1, y1, x2, y2, scale, color) {
    scale = 1;
    const rectangleSeatObj = new fabric.Line([x1, y1, x2, y2], {
      stroke: color,
      strokeWidth: (5),
      //strokeLineCap: 'round'
    });
    rectangleSeatObj.set({
      name: 'seat'
    });
    return rectangleSeatObj;
  }

  curvedSeat(seat, radius, seatColor, tblFillColor, that, obj, startAngle, color?) {
    const seatWidth = seat * 25;
    const lastend = 0;
    const myTotal = seat * 8;
    const tableObj1 = [];
    const strokeColor = '';
    const table = obj._objects.filter(x => x.name == 'shape')[0];
    const radiusAssigned = ((table.width * table.scaleX) / 2) + (6.5);
    const circleSeat = new fabric.Ellipse({
      left: obj.Left > 14 ? obj.Left : 14,
      top: obj.Top > 14 ? obj.Top : 14,
      height: (obj.Height - 16) < 60 ? (60 + 3) : obj.MaxPartySize > 2 ? obj.Height - 16 + 3 : obj.Height + 3,
      width: (obj.Width - 16) < 60 ? (60 + 3) : obj.Width - 16 + 3,
      fill: color,
      stroke: strokeColor,
      strokeWidth: 5
    });

    circleSeat.set({
      name: 'seat',
    });

    return circleSeat;
  }

  drawCircleSeat(obj, that, colorData) {
    const color = '#444444';
    const seatWidth = 5 * 5;
    const radius = obj.radius;
    return this.roundSeatDraw(obj.MaxPartySize > 6 ? 6 : obj.MaxPartySize, radius, color, 'green', this, obj, color); // green,blue
  }

  roundSeatDraw(seat, radius, seatColor, tblFillColor, that, obj, color?) {
    const seatWidth = seat * 25;
    const lastend = 0;
    const myTotal = seat * 8;
    let startAngle = 0;
    const tableObj1 = [];
    const strokeColor = '';
    const table = obj._objects.filter(x => x.name == 'shape')[0];
    for (let i = 0; i < seat; i++) {
      const circleSeat = new fabric.Circle({
        radius: ((table.width * table.scaleX) / 2) + 3,
        startAngle: startAngle - ((Math.PI * 2) / myTotal),
        endAngle: startAngle + ((Math.PI * 2) / myTotal),
        stroke: seatColor,
        strokeWidth: (5),
        fill: '',
        //strokeLineCap: 'round',
        // cornerSize: 25,
        //cornerStyle: 'circle',
        top: obj.top,
        left: obj.left,
        originX: 'center',
        originY: 'center',
      });

      circleSeat.set({
        name: 'seat',
      });

      startAngle += Math.PI * 2 * ((myTotal / seat) / myTotal);
      tableObj1.push(circleSeat);
    }
    return tableObj1;
  }

  drawEllipseSeat(obj, that, color) {
    const objectWidth = obj.width;
    const objectHeight = obj.height;
    let setArray;
    const partySize = obj.MaxPartySize > 6 ? 6 : obj.MaxPartySize;
    setArray = ['top', 'bottom'];
    const radius = obj.radius;
    const seat = obj.MaxPartySize > 6 ? 6 : obj.MaxPartySize;
    const myTotal = seat * 8;
    var startAngle = Math.PI * 2 * ((myTotal / seat) / myTotal);

    return this.curvedSeat(obj.MaxPartySize > 6 ? 6 : obj.MaxPartySize, radius, color, 'green', this, obj, startAngle, color);
  }

  checkTableiscircle(object) {
    const checkdiff = object.Width - object.Height;
    return Math.abs(checkdiff) < 15 ? ShapeTypeEnum.Circle : ShapeTypeEnum.Ellipse;
  }

  scaleObjects(canvas, scaleFactorX, scaleFactorY, scaleFactor, BasedOn?, isImage?) {
    const objects = canvas.getObjects();
    for (const i in objects) {
      this.scaleObject(objects[i], scaleFactorX, scaleFactorY, scaleFactor, BasedOn);
    }
    canvas.renderAll();
    canvas.calcOffset();
  }

  scaleObject(object, scaleFactorX, scaleFactorY, scaleFactor, BasedOn?) {
    const scaleX = object.scaleX;
    const scaleY = object.scaleY;
    const left = object.left;
    const top = object.top;
    const shapetype = object.name == 'area';
    let scalefactorneed = false;
    if (object._objects) {
      let shape = object._objects.filter(x => x.name == 'shape');
      if (shape && shape.length) {
        let shapetypetable = shape[0].get('type');
        scalefactorneed = false;
        if (!shapetype && shapetypetable == ShapeTypeEnum.Rectangle && BasedOn == undefined) {
          scalefactorneed = this.getbigRectangle(object.width, object.height);
        }
      }
    }
    const tempScaleX = scaleX * (shapetype || scalefactorneed ? scaleFactorX : scaleFactor);
    const tempScaleY = scaleY * (shapetype || scalefactorneed ? scaleFactorY : scaleFactor);
    const tempLeft = left * scaleFactorX;
    const tempTop = top * scaleFactorY;
    if (object.points) {

      object.scaleX = scaleFactorX;
      object.scaleY = scaleFactorY;
      object.left = tempLeft;
      object.top = tempTop;
    } else {
      object.scaleX = tempScaleX;
      object.scaleY = tempScaleY;
      object.left = tempLeft;
      object.top = tempTop;
    }
    object.setCoords();
  }
  
  getbigRectangle(Width, Height) {
    const checkdiff = Width < Height;
    let finalval = Height / Width;
    if (!checkdiff) {
      finalval = Width / Height;
    }
    return Math.abs(finalval) > (1.25);
  }
}
